module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN331_1015599139.2e6c1341.png";